export default "__VITE_ASSET__CQK0mHiJ__"